import React, { useState } from "react";
import { Modal, Table, Button, Icon } from "semantic-ui-react";
import { TABLE_FORMAT_REGEX } from "../constants/CustomFields";

const TableCustomFieldModal = ({ fieldName, fieldValue, trigger }) => {
  const [open, setOpen] = useState(false);

  // Parse the table format string into rows and columns
  const parseTableData = tableString => {
    if (!tableString || !TABLE_FORMAT_REGEX.test(tableString)) {
      return { headers: [], rows: [] };
    }

    try {
      // Split by semicolons to get rows
      const rows = tableString
        .split(";")
        .map(row => row.trim())
        .filter(row => row.length > 0);

      if (rows.length === 0) {
        return { headers: [], rows: [] };
      }

      // Parse CSV-style rows using a similar approach to the backend
      const parseRow = rowStr => {
        const cells = [];
        let current = "";
        let inQuotes = false;
        let i = 0;

        while (i < rowStr.length) {
          const char = rowStr[i];

          if (char === '"' && !inQuotes) {
            inQuotes = true;
          } else if (char === '"' && inQuotes) {
            if (i + 1 < rowStr.length && rowStr[i + 1] === '"') {
              // Escaped quote
              current += '"';
              i++; // Skip next quote
            } else {
              inQuotes = false;
            }
          } else if (char === "," && !inQuotes) {
            cells.push(current.trim());
            current = "";
          } else {
            current += char;
          }
          i++;
        }

        if (current.trim().length > 0) {
          cells.push(current.trim());
        }

        return cells;
      };

      const parsedRows = rows.map(parseRow);
      const headers = parsedRows[0] || [];
      const dataRows = parsedRows.slice(1);

      return { headers, rows: dataRows };
    } catch (error) {
      console.error("Error parsing table data:", error);
      return { headers: [], rows: [] };
    }
  };

  const { headers, rows } = parseTableData(fieldValue);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Clone the trigger element and add click handler
  const triggerWithHandler = React.cloneElement(trigger, {
    onClick: handleOpen,
    style: {
      ...trigger.props.style,
    },
  });

  return (
    <Modal
      trigger={triggerWithHandler}
      open={open}
      onClose={handleClose}
      size="large"
    >
      <Modal.Header>
        <Icon name="table" />
        {fieldName}
      </Modal.Header>
      <Modal.Content>
        {headers.length > 0 ? (
          <div style={{ overflowX: "auto", maxWidth: "100%" }}>
            <Table celled striped>
              <Table.Header>
                <Table.Row>
                  {headers.map((header, index) => (
                    <Table.HeaderCell key={index}>{header}</Table.HeaderCell>
                  ))}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {rows.map((row, rowIndex) => (
                  <Table.Row key={rowIndex}>
                    {headers.map((_, colIndex) => (
                      <Table.Cell key={colIndex}>
                        {row[colIndex] || ""}
                      </Table.Cell>
                    ))}
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
        ) : (
          <div>
            <p>Unable to parse table data. Raw value:</p>
            <pre
              style={{
                background: "#f5f5f5",
                padding: "10px",
                borderRadius: "4px",
              }}
            >
              {fieldValue}
            </pre>
          </div>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleClose}>
          <Icon name="checkmark" /> Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default TableCustomFieldModal;
